import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import LinearProgress from "@mui/material/LinearProgress";
import { useEffect } from "react";
import { useMessage } from "../Message/MessageContext";

import { LoadingButton } from "../../components/Loading";
import { statusCancelamentoAgendamento } from "../Agendamento/AgendamentoContext";
import { useSave } from "./useSave";

const motivos = Object.values(statusCancelamentoAgendamento);

export const Cancelar = ({ agendamentoId, onClose }) => {
  const {
    save,
    setorAtendimento,
    dataAgendamento,
    descricao,
    setDescricao,
    savedItem,
    isLoading,
    status,
    setStatus,
    isSaving,
    ausenciaJustificada,
    setAusenciaJustificada,
  } = useSave(agendamentoId);

  const { setSuccess } = useMessage();

  const showCheckbox =
    status === statusCancelamentoAgendamento.naoRealizado ||
    status === statusCancelamentoAgendamento.pacienteNaoCompareceu;

  const onSubmit = async (e) => {
    e.preventDefault();
    save();
  };

  useEffect(() => {
    if (savedItem) {
      setSuccess("Agendamento cancelado com sucesso");
      onClose(savedItem);
    }
  }, [savedItem]);

  return (
    <Dialog open={true} onClose={() => onClose()} fullWidth maxWidth="md">
      <DialogTitle>Cancelar agendamento</DialogTitle>
      <form onSubmit={onSubmit}>
        <DialogContent>
          <Box mb={2}>
            {isLoading ? (
              <LinearProgress />
            ) : (
              <Alert severity="warning">
                Deseja realmente cancelar o agendamento do dia{" "}
                <strong>
                  {dataAgendamento
                    ? format(new Date(dataAgendamento), "dd/MM/yyyy H:mm")
                    : ""}{" "}
                </strong>
                com o setor <strong>{setorAtendimento?.nome}</strong>?
              </Alert>
            )}
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={motivos}
                value={motivos.includes(status) ? status : ""}
                onChange={(e, status) => setStatus(status)}
                fullWidth
                autoFocus
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Motivo"
                    variant="outlined"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(e) => setDescricao(e.target.value)}
                value={descricao}
                label="Obs."
              />
            </Grid>
            {showCheckbox && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!ausenciaJustificada}
                      onChange={(e) =>
                        setAusenciaJustificada(e.target.checked || null)
                      }
                      value="remember"
                      color="primary"
                    />
                  }
                  label="Ausência justificada"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {!isLoading && (
            <LoadingButton
              loading={isSaving}
              variant="outlined"
              type="submit"
              color="primary"
            >
              Confirmar
            </LoadingButton>
          )}
          <Button onClick={() => onClose()}>Cancelar</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
